import React, {Component} from 'react';
import Select from 'react-select';
import {Button} from 'react-bootstrap';
import Utils from "./Utils";

export default class ContractItem extends Component {
    constructor() {
        super();

        this.state = {
            units: [],
            item: {},
        };

        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.handleMeasurementUnitChange = this.handleMeasurementUnitChange.bind(this);
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.handleUnitPriceChange = this.handleUnitPriceChange.bind(this);
        this.handleTotalChange = this.handleTotalChange.bind(this);
        this.handleVatChange = this.handleVatChange.bind(this);
        this.handleTotalVatChange = this.handleTotalVatChange.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.calculateTotalFromQuantity = this.calculateTotalFromQuantity.bind(this);
        this.populateItem = this.populateItem.bind(this);
    }

    populateItem(props) {
        let units = props.units;
        let item = props.item;

        this.setState({
            units: units,
            item: item,
        }, () => {
            if (this.state.item.quantity_comma !== undefined) {
                let quantity = parseFloat(this.state.item.quantity_comma.replace(",", "."));
                let total = this.calculateTotalFromQuantity(quantity);
                let total_vat = this.calculateTotalVATFromTotal(total);

                let item = this.state.item;
                item.total = total;
                item.total_vat = total_vat;
                this.setState({item: item});
            }
        });
    }

    componentWillMount() {
        this.populateItem(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.populateItem(nextProps);
    }

    handleDescriptionChange(e) {
        let item = this.state.item;
        item.description = e.target.value;
        this.setState({description: e.target.value, item: item});
    }

    handleMeasurementUnitChange(e) {
        let measurement_unit_id = "";
        if (e !== null)
            measurement_unit_id = e.value;

        let item = this.state.item;
        item.measurement_unit_id = measurement_unit_id;
        this.setState({item: item});
    }

    calculateTotalFromQuantity(quantity) {
        let total = "";
        if (this.state.item.unit_price_comma !== undefined && this.state.item.unit_price_comma !== "") {
            let unit_price = parseFloat(this.state.item.unit_price_comma.replace(",", "."));
            if (!isNaN(quantity) && !isNaN(unit_price)) {
                total = quantity * unit_price;
                total = total.toFixed(5).replace(".", ",");
            }
        }
        return total;
    }

    calculateTotalFromUnitPrice(unit_price) {
        let total = "";
        if (this.state.item.quantity_comma !== undefined && this.state.item.quantity_comma !== "") {
            let quantity = parseFloat(this.state.item.quantity_comma.replace(",", "."));
            if (!isNaN(quantity) && !isNaN(unit_price)) {
                total = unit_price * quantity;
                total = total.toFixed(5).replace(".", ",");
            }
        }
        return total;
    }

    calculateTotalVATFromTotal(total) {
        total = parseFloat(total.replace(',', '.'));

        let total_vat = '';
        let vat_comma = this.state.item.vat_comma;

        if (typeof vat_comma === 'undefined' || vat_comma === '') {
            vat_comma = '0';
        }

        let vat = parseFloat(vat_comma.replace(',', '.'));

        if (!isNaN(total) && !isNaN(vat)) {
            total_vat = (1 + (vat / 100)) * total;
            total_vat = total_vat.toFixed(5).replace('.', ',');
        }

        return total_vat;
    }

    calculateTotalVATFromVAT(vat) {
        let total_vat = "";
        if (this.state.item.total !== undefined && this.state.item.total !== "") {
            let total = parseFloat(this.state.item.total.replace(",", "."));
            if (!isNaN(total) && !isNaN(vat)) {
                vat = vat / 100.0;
                vat = vat + 1.0;
                total_vat = vat * total;
                total_vat = total_vat.toFixed(5).replace(".", ",");
            }
        }
        return total_vat;
    }

    handleQuantityChange(e) {
        let value = Utils.handleDecimals(e.target.value);

        let quantity = parseFloat(e.target.value.replace(",", "."));
        let total = this.calculateTotalFromQuantity(quantity);
        let total_vat = this.calculateTotalVATFromTotal(total);

        let item = this.state.item;
        item.quantity_comma = value;
        item.total = total;
        item.total_vat = total_vat;
        this.setState({item: item});
    }

    handleUnitPriceChange(e) {
        let value = Utils.handleDecimals(e.target.value);

        let unit_price = parseFloat(e.target.value.replace(",", "."));
        let total = this.calculateTotalFromUnitPrice(unit_price);
        let total_vat = this.calculateTotalVATFromTotal(total);

        let item = this.state.item;
        item.unit_price_comma = value;
        item.total = total;
        item.total_vat = total_vat;
        this.setState({item: item});
    }

    handleTotalChange(e) {
        let item = this.state.item;
        item.total = e.target.value;
        this.setState({item: item});
    }

    handleVatChange(e) {
        let value = Utils.handleDecimals(e.target.value);

        let vat = e.target.value.replace(",", ".").trim();

        if (vat.length === 0) {
            vat = 0.0;
        } else {
            vat = parseFloat(vat);
        }

        let total_vat = this.calculateTotalVATFromVAT(vat);

        let item = this.state.item;
        item.vat_comma = value;
        item.total_vat = total_vat;
        this.setState({item: item});
    }

    handleTotalVatChange(e) {
        let item = this.state.item;
        item.total_vat = e.target.value;
        this.setState({item: item});
    }

    removeItem() {
        this.props.removeFn(this.state.item.key);
    }

    render() {
        return (
            <div className="like-row">
                <div className="num like-cell">
                    <div className="cell-label"></div>
                    <div className="cell-value item-number">{this.state.item.num}</div>
                </div>

                <div className="description like-cell">
                    <div className="cell-label">{window.__js_contracts.item_description}*</div>
                    <div className="cell-value">
                        <textarea name={"items[" + this.state.item.key + "][description]"}
                                  value={this.state.item.description}
                                  className="form-control"
                                  onChange={this.handleDescriptionChange}></textarea>
                    </div>
                </div>

                <div className="measurement-unit like-cell">
                    <div className="cell-label">{window.__js_contracts.measurement_unit}*</div>
                    <div className="cell-value">
                        <Select name={"items[" + this.state.item.key + "][measurement_unit_id]"}
                                value={this.state.item.measurement_unit_id}
                                options={this.state.units}
                                onChange={this.handleMeasurementUnitChange}/>
                    </div>
                </div>

                <div className="quantity like-cell">
                    <div className="cell-label">{window.__js_contracts.quantity}*</div>
                    <div className="cell-value">
                        <input type="text"
                               name={"items[" + this.state.item.key + "][quantity_comma]"}
                               value={this.state.item.quantity_comma}
                               className="form-control"
                               onChange={this.handleQuantityChange}/>
                    </div>
                </div>

                <div className="unit-price like-cell">
                    <div className="cell-label">{window.__js_contracts.unit_price}*</div>
                    <div className="cell-value">
                        <input type="text"
                               name={"items[" + this.state.item.key + "][unit_price_comma]"}
                               value={this.state.item.unit_price_comma}
                               className="form-control"
                               onChange={this.handleUnitPriceChange}/>
                    </div>
                </div>

                <div className="total like-cell">
                    <div className="cell-label">{window.__js_contracts.total_without_vat}</div>
                    <div className="cell-value">
                        <input type="text"
                               name={"items[" + this.state.item.key + "][total]"}
                               value={this.state.item.total}
                               disabled={true}
                               className="form-control"/>
                    </div>
                </div>

                <div className="vat like-cell">
                    <div className="cell-label">{window.__js_contracts.vat_rate}*</div>
                    <div className="cell-value">
                        <input type="text"
                               name={"items[" + this.state.item.key + "][vat_comma]"}
                               value={this.state.item.vat_comma}
                               className="form-control"
                               onChange={this.handleVatChange}/>
                    </div>
                </div>

                <div className="total-vat like-cell">
                    <div className="cell-label">{window.__js_contracts.total_with_vat}</div>
                    <div className="cell-value">
                        <input type="text"
                               name={"items[" + this.state.item.key + "][total_vat]"}
                               value={this.state.item.total_vat}
                               disabled={true}
                               className="form-control"/>
                    </div>
                </div>

                <div className="remove like-cell">
                    <div className="cell-label"></div>
                    <div className="cell-value">
                        <Button onClick={this.removeItem}
                                bsStyle="danger">
                            <i className="fa fa-minus"></i>
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}